import { createStore, Store, useStore }           from 'vuex';
import { CatalogCpqJson, CpqCartProductLineJson } from '@/libs/cpq-builder/cpq-json.interface';
import { salesqueze }                             from '@/libs/salesqueze-sdk-browser';
import { StateInterface }                         from '@/store/util';

const mutations = {
  // SaleSqueze
  addProductToCart  : (state: StateInterface, product: CpqCartProductLineJson) => {
    state.cpq.cart.products.push(product);
    localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  updateCartProducts: (state: StateInterface, cartProducts: CpqCartProductLineJson[]) => {
    state.cpq.cart.products = cartProducts;
    localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  removeCartProduct : (state: StateInterface, indexOrObjRef: number | CpqCartProductLineJson) => {
    state.cpq.cart.products = state.cpq.cart.products.filter((x, i) => x !== indexOrObjRef && i !== indexOrObjRef);
    localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  clearCart         : (state: StateInterface) => {
    state.cpq.cart.products = [];
    localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  submit            : async (state: StateInterface) => {
    const data = await salesqueze.createDocument('cpq', {
      cpq: state.cpq
    });
    console.log('Sending data', data);
    mutations.clearCart(state);
  },

  // App
  setAutomatedGuideFlow: (state: StateInterface, x: boolean) => {
    state.automatedGuideFlow = x;
  },
  setPreviewImageUrl: (state: StateInterface, url: string) => {
    state.previewImageUrl = url;
  },
  setLinijaList: (state: StateInterface, x: any) => {
    state.linijaList = x;
  },
  setOblikaList: (state: StateInterface, x: any) => {
    state.oblikaList = x;
  },
  setResponseTiles: (state: StateInterface, data: any) => {
    state.responseTiles = data;
  },
  setSelectedTiles: (state: StateInterface, data: any) => {
    state.selectedTiles = data;
  },
  setResponseCurbs: (state: StateInterface, data: any) => {
    state.responseCurbs = data;
  },
  setCurbs: (state: StateInterface, data: any) => {
    state.curbs = data;
  },
  setResponseScarpElements: (state: StateInterface, data: any) => {
    state.responseScarpElements = data;
  },
  setScarpElements: (state: StateInterface, data: any) => {
    state.scarpElements = data;
  },
  setGroutSlider: (state: StateInterface, data: any) => {
    state.groutSlider = data;
  },
  setResponseGrouts: (state: StateInterface, data: any) => {
    state.responseGrouts = data;
  },
  setGrouts: (state: StateInterface, data: any) => {
    state.grouts = data;
  },
  setImpregnationSlider: (state: StateInterface, data: any) => {
    state.impregnationSlider = data;
  },
  setResponseImpregnation: (state: StateInterface, data: any) => {
    state.responseImpregnation = data;
  },
  setImpregnation: (state: StateInterface, data: any) => {
    state.impregnation = data;
  },
  setResponseAddons: (state: StateInterface, data: any) => {
    state.responseAddons = data;
  },
  setAddons: (state: StateInterface, data: any) => {
    state.addons = data;
  },
  setContact: (state: StateInterface, data: any) => {
    state.contact = data;
  },
  setSalonList: (state: StateInterface, data: any) => {
    state.salonList = data;
  },
  setSalon: (state: StateInterface, data: any) => {
    state.salon = data;
  },
  setScreenshot: (state: StateInterface, data: any) => {
    state.screenshot = data;
  },
  set_takeScreenshot: (state: StateInterface, data: any) => {
    state.takeScreenshot = data;
  },
  setErrors: (state: StateInterface, data: any) => {
    state.errors = data;
  },
  setActiveErrors: (state: StateInterface, data: any) => {
    state.activeErrors = data;
  },
  incrementCounter: (state: StateInterface) => {
    if(state.counter){
      state.counter++
    } else {
      state.counter = 1;
    }
  },
  setProducts: (state: StateInterface, data: any) => {
    state.products = data;
  },
  incrementMeshCreated: (state: StateInterface) => {
    if(state.meshCreated){
      state.meshCreated++
    } else {
      state.meshCreated = 1;
    }
  },
};

export const actions = {
  async addProductToCart({ commit }: any, product: CpqCartProductLineJson) {
    await commit('addProductToCart', product);
  },
  async updateCartProducts({ commit }: any, cartProducts: CpqCartProductLineJson[]) {
    await commit('updateCartProducts', cartProducts);
  },
  async removeCartProduct({ commit }: any, indexOrObjRef: number | CpqCartProductLineJson) {
    await commit('removeCartProduct', indexOrObjRef);
  },
  async clearCart({ commit }: any) {
    await commit('clearCart');
  },
  async submit({ commit }: any) {
    await commit('submit');
  },
};

export default createStore({
  getters: {
    getProducts: (state: StateInterface) => state.catalog.products
  },
  state  : {
    catalog: {
      products: []
    },
    cpq    : {
      cart: {
        products: JSON.parse(localStorage.getItem('state.cpq.cart.products') || '[]')
      }
    }
  } as StateInterface,
  mutations,
  actions,
  modules: {},
});
